import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/app/quick-access/sections/",
)({
  component: () => <div>Hello /_authenticated/app/quick-access/sections/!</div>,
});
